import React from 'react';
import { Remote } from '@okapi/remote';
import { css } from 'linaria';
import { useStretchBannerData } from 'common/hooks';
import { getIsSponsoredStretchBannerDisabled } from 'common/selectors';
import { useSelector } from 'react-redux';

const wrapper = css`
  width: 100%;
`;

export function StretchBanner() {
  const hideStretchBanner = useSelector(getIsSponsoredStretchBannerDisabled);
  const { stretchBannerData } = useStretchBannerData();

  if (hideStretchBanner || !stretchBannerData) return null;

  return (
    <Remote
      className={wrapper}
      widget="placements/banner"
      id="pdp-stretch-banner"
      data={stretchBannerData}
      serverTimeout={1000}
    />
  );
}
